module.exports = __webpack_public_path__ + "media/soundtrack.3734428c.mp3";